import { useTranslation } from 'react-i18next';
import { AmountUtils, cn, CurrencyUtils } from '@shared/utils';
import { AccountStatus, type AccountResponse } from '@shared/api';
import { Text } from '@shared/widgets';

interface AccountVcfcHeaderProps {
  className?: string;
  account: AccountResponse;
  viewAvailableBalance?: boolean;
}

export const AccountVcfcHeader = (props: AccountVcfcHeaderProps) => {
  const { t } = useTranslation('accounts');

  return (
    <div className={cn('flex flex-col gap-2 p-4', props.className)}>
      <div className='flex justify-between'>
        <Text size='3xl'>
          {props.viewAvailableBalance ? AmountUtils.transformToAmountWithCurrency(props.account.balance, props.account.currency) : '****'}
        </Text>
        <div
          className={cn(
            'flex h-[29px] min-w-[65px] items-center justify-center gap-2 rounded-[45px] px-2 text-white',
            props.account.status === AccountStatus.Active && 'bg-primary dark:bg-white',
            ([AccountStatus.Blocked, AccountStatus.Delinquent] as AccountStatus[]).includes(props.account.status) && 'bg-red',
            ([AccountStatus.Closed, AccountStatus.Dormant] as AccountStatus[]).includes(props.account.status) && 'bg-light/70',
          )}
        >
          <Text weight='medium' color='primary-reverse'>
            {CurrencyUtils.getSymbolByCode(props.account.currency)}
          </Text>
          <Text weight='semibold' size='xxs' color='primary-reverse'>
            {t(`statuses.account.${props.account.status}`, { ns: 'common' })}
          </Text>
        </div>
      </div>
      <div className='flex flex-col gap-1'>
        <Text weight='medium' size='xs' color='secondary'>
          {props.account.name}
        </Text>
        <Text size='xxs' weight='semibold' color='gray'>
          {props.account.productName}
        </Text>
        <Text weight='medium'>{props.account.name}</Text>
      </div>
    </div>
  );
};
